module.exports = __webpack_public_path__ + "img/sixth_amulet.459afd40.jpg";